import { createdATFilter } from 'modules/common/constants';

export const labelsFilters = [createdATFilter];
